export const STATS_TRANSLATION = {
  best_monthly_return: 'Maior retorno',
  worst_monthly_return: 'Menor retorno',
  positive_months: 'Meses Positivos',
  negative_months: 'Meses Negativos',
  '12_months_average_networth': 'PL Médio 12M',
  networth: 'Patrimônio líquido',
  quota_holders: 'Cotistas',
  positive_months_percent: 'Percentual de meses positivos',
  negative_months_percent: 'Percentual de meses positivos',
  timeframe: {
    last_3_months: {
      profitability: 'Rentabilidade 3M',
      volatility: 'Volatilidade 3M',
      sharpe_ratio: 'Índice de Sharpe 3M',
    },
    last_6_months: {
      profitability: 'Rentabilidade 6M',
      volatility: 'Volatilidade 6M',
      sharpe_ratio: 'Índice de Sharpe 6M',
    },
    last_12_months: {
      profitability: 'Rentabilidade 12M',
      volatility: 'Volatilidade 12M',
      sharpe_ratio: 'Índice de Sharpe 12M',
    },
    last_24_months: {
      profitability: 'Rentabilidade 24M',
      volatility: 'Volatilidade 24M',
      sharpe_ratio: 'Índice de Sharpe 24M',
    },
    last_36_months: {
      profitability: 'Rentabilidade 36M',
      volatility: 'Volatilidade 36M',
      sharpe_ratio: 'Índice de Sharpe 36M',
    },
    ytd: {
      profitability: 'Rentabilidade no ano',
      volatility: 'Volatilidade no ano',
      sharpe_ratio: 'Índice de Sharpe no ano',
    },
    mtd: {
      profitability: 'Rentabilidade no mês',
      volatility: 'Volatilidade no mês',
      sharpe_ratio: 'Índice de Sharpe no mês',
    },
    begin: {
      profitability: 'Rentabilidade no início',
      volatility: 'Volatilidade no início',
      sharpe_ratio: 'Índice de Sharpe no início',
    },
  },
};
